import React, { useState, useEffect } from 'react';
import './event.dropdown.scss';

const TribesDropdown = ({selectedEvent, setSelectedEvent, eventList}) => {
  const [showPane, setShowPane] = useState(false);
  const [rotate, setRotate] = useState('');
  const [tagOn, setTagOn] = useState(false);

  const rotateArrow = () => {
    setRotate(rotate === 'rotate-180' ? 'rotate-360' : 'rotate-180');
  };

  const handleSelectboxClick = (e) => {
    setShowPane(!showPane);
    rotateArrow();
  };

  const handleClick = (event) => {
    setSelectedEvent(event);
    setShowPane(false);
    rotateArrow();
  };


  return (
    <div className="insights-calendar-dropdown-container">
      <div
        className={`filter event-selectbox ${tagOn ? 'event-selected' : ''}`}
        onClick={handleSelectboxClick}
      >
        <div className="selected-event">
            <div className='insights-event-dropdown-wrapper'>
              {eventList[eventList.findIndex(event => event.id === selectedEvent?.id)]?.name}
            </div>
        </div>
        <div className={`selectbox-arrow ${rotate}`}></div>
      </div>
      <div className={`tag-list-pane ${showPane ? 'show' : 'hide'}`}>
        {eventList.map((event, key) => {
          return (
            <div
              className={`event-item ${selectedEvent?.id === event?.id && 'selected'}`}
              onClick={() => handleClick(event)}
              key={`item-${key}`}
            >
              <div className=''>
                {event.name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TribesDropdown;
